export default {
    READY: 0,
    DOWNLOADING: 1,
    DOWNLOADED: 2,
};
